// Modal for picking a Loss_Reason__c picklist value when closing a
// prospect as lost or marking as unqualified. Required: SF rejects
// freeform text on this field, only the picklist values it knows.

import { useState, useEffect } from 'react';

export default function CloseReasonModal({ title, prospectName, options, onConfirm, onCancel, confirmLabel = 'Confirm' }) {
  const [selected, setSelected] = useState(options[0]?.value || '');

  useEffect(() => {
    function onKey(e) { if (e.key === 'Escape') onCancel?.(); }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCancel]);

  function handleConfirm() {
    if (!selected) return;
    onConfirm?.(selected);
  }

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[60] p-4" onClick={onCancel}>
      <div className="bg-white rounded-[4px] shadow-[0_8px_30px_rgba(0,0,0,0.18)] w-[440px] max-w-full p-5" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-[14px] font-bold text-navy">{title}</h3>
          <button onClick={onCancel} className="text-[20px] text-[#888] hover:text-navy leading-none px-1">×</button>
        </div>
        {prospectName && (
          <p className="text-[11px] text-[#888] mb-3">For <span className="font-bold text-navy">{prospectName}</span></p>
        )}

        <div className="space-y-1.5 mb-4">
          {options.map(opt => (
            <label
              key={opt.value}
              className={`flex items-start gap-2 px-3 py-2 rounded-[3px] cursor-pointer text-[12px] ${
                selected === opt.value ? 'bg-bullogic-blue/10 border border-bullogic-blue' : 'border border-gray-200 hover:bg-bone/40'
              }`}
            >
              <input
                type="radio"
                name="loss-reason"
                value={opt.value}
                checked={selected === opt.value}
                onChange={() => setSelected(opt.value)}
                className="mt-0.5"
              />
              <div className="flex-1">
                <div className="font-bold text-navy">{opt.label}</div>
                {opt.value !== opt.label && (
                  <div className="text-[10px] text-[#888] font-mono">{opt.value}</div>
                )}
              </div>
            </label>
          ))}
        </div>

        <div className="flex justify-end gap-2 pt-2 border-t border-gray-100">
          <button onClick={onCancel} className="px-3 py-1.5 text-[12px] font-bold text-[#888] bg-gray-100 hover:bg-gray-200 rounded-[3px]">Cancel</button>
          <button
            onClick={handleConfirm}
            className="px-3 py-1.5 text-[12px] font-bold text-white bg-rose hover:bg-rose/90 rounded-[3px]"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
